import * as Sentry from '@sentry/react';
import { SENTRY_DSN } from './config';

/**
 * Browser errors to Sentry (EU region, project timefly-web), only when /config.js names a DSN (2026-10-19).
 * No replay, no tracing; the browser SDK sends no IP or cookies unless told to. Addresses lose their query before they leave: demo and sign-in
 * links carry one-time tokens there (?token=).
 */
export const noQuery = (u: unknown): unknown => (typeof u === 'string' ? u.replace(/[?#].*/s, '') : u);

export function scrub<E extends { request?: { url?: string }; user?: { id?: string | number } }>(
  event: E,
): E {
  const { user, request, ...rest } = event;
  return {
    ...rest,
    ...(request ? { request: { url: noQuery(request.url) as string } } : {}),
    ...(user?.id != null ? { user: { id: user.id } } : {}),
  } as E;
}

export function startErrorReporting(dsn = SENTRY_DSN): boolean {
  if (!dsn) return false;
  Sentry.init({
    dsn,
    environment: location.hostname === 'app.timefly.no' ? 'production' : 'other',
    tracesSampleRate: 0,
    beforeSend: (event) => scrub(event),
    beforeBreadcrumb: (crumb) => {
      if (crumb.category === 'console') return null; // what the app prints is not vetted for personal data
      if (crumb.data)
        for (const k of ['url', 'from', 'to']) if (k in crumb.data) crumb.data[k] = noQuery(crumb.data[k]);
      return crumb;
    },
  });
  return true;
}
